// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__lQYQe","tableHeader":"styles_tableHeader__3LXjF","archive":"styles_archive__1iqrY","viewArchive":"styles_viewArchive__3QLYd"};